import MetaData from './MetaTags';

export default MetaData;